import { apiClient } from "../../../../services/apiClient";

const variantSelectorApi = {
  getObjectTypes: async (activeFile = null) => {
    try {
      const params = activeFile ? { file_type: activeFile } : {};
      const response = await apiClient.get('/object-types', { params });
      const data = response.data;
      if (data && (Array.isArray(data.objectTypes) || Array.isArray(data))) {
        return Array.isArray(data.objectTypes) ? data.objectTypes : data;
      }
      throw new Error('Invalid object types response format');
    } catch (error) {
      console.error('Error fetching object types:', error);
      throw new Error(`Failed to fetch object types: ${error.message}`);
    }
  },

  filterOCELByVariants: async (objectType, selectedObjectIds, activeFile = null) => {
    try {
      const response = await apiClient.post("/filter-ocel-by-variants", {
        file_type: activeFile || 'main',
        object_type: objectType,
        selected_object_ids: selectedObjectIds,
      });

      if (response && response.data?.status === "success") {
        console.log("OCEL successfully filtered.");
        return response.data;
      } else {
        throw new Error(
          "Filtering OCEL failed or returned unexpected response."
        );
      }
    } catch (error) {
      console.error(
        "Error filtering OCEL:",
        error.response || error.message || error
      );
      throw error;
    }
  },

  // Get variants with global filters applied (excluding variant filters)
  getFilteredVariants: async (objectType, activeFile = null, globalFilterRequest = {}, activityFilter = null) => {
    try {
      console.log(`Getting filtered variants for object type: ${objectType} with filters:`, globalFilterRequest);

      // Build request with global filters excluding variant filters
      const requestData = {
        object_type: objectType,
        selected_variant_ids: [],
        ...globalFilterRequest
      };

      // Add activity filter if provided
      if (activityFilter) {
        requestData.activity_filter = activityFilter;
        console.log(`Activity filter applied:`, activityFilter);
      }

      const response = await apiClient.post("/variant-display", requestData);

      if (
        response &&
        typeof response.data === "object" &&
        response.data !== null
      ) {
        console.log("Filtered variants fetched successfully.");
        return response.data;
      } else {
        throw new Error("Failed to fetch filtered variants.");
      }
    } catch (error) {
      console.error(
        "Error fetching filtered variants:",
        error.response || error.message || error
      );
      throw error;
    }
  },

  // Get unfiltered variant data (bypasses global filters) - kept for backward compatibility
  getUnfilteredVariants: async (objectType, activeFile = null) => {
    try {
      console.log(`Getting unfiltered variants for object type: ${objectType}`);

      const response = await apiClient.post("/variant-display", {
        file_type: activeFile || 'main',
        object_type: objectType,
        selected_variant_ids: [],
      });

      if (
        response &&
        typeof response.data === "object" &&
        response.data !== null
      ) {
        console.log("Unfiltered variants fetched successfully.");
        return response.data;
      } else {
        throw new Error("Failed to fetch unfiltered variants.");
      }
    } catch (error) {
      console.error(
        "Error fetching unfiltered variants:",
        error.response || error.message || error
      );
      throw error;
    }
  },

  resetOCEL: async (objectType, activeFile = null) => {
    try {
      console.log(`Resetting OCEL for object type: ${objectType}`);

      const response = await apiClient.post("/variant-display", {
        file_type: activeFile || 'main',
        object_type: objectType,
        selected_variant_ids: [],
      });

      if (
        response &&
        typeof response.data === "object" &&
        response.data !== null
      ) {
        console.log("OCEL successfully reset via variant-display.");
        return response.data;
      } else {
        throw new Error("Reset failed or unexpected response.");
      }
    } catch (error) {
      console.error(
        "Error resetting OCEL:",
        error.response || error.message || error
      );
      throw error;
    }
  },
};

export default variantSelectorApi;